import { useState, useEffect } from 'react';

export function useGridDimensions(parentRef, minColWidth, gridGap, rowPadding, infoHeightApprox) {
  const [columns, setColumns] = useState(5);
  const [rowHeight, setRowHeight] = useState(385);

  useEffect(() => {
    if (!parentRef.current) return;
    const el = parentRef.current;

    const compute = () => {
      const width = el.clientWidth;
      const gridUsable = Math.max(0, width - rowPadding * 2);
      const cols = Math.max(1, Math.floor((gridUsable + gridGap) / (minColWidth + gridGap)));
      const gapsTotal = gridGap * Math.max(0, cols - 1);
      const colWidth = Math.floor((gridUsable - gapsTotal) / cols);
      // Reihenhöhe = Tile-Höhe (≈ colWidth*1.4 Bild + Info) + ein gridGap als
      // vertikaler Reihenabstand. So ist der vertikale Abstand identisch zum
      // horizontalen Spaltenabstand (rowPadding wird nicht mehr addiert).
      const estimatedRowHeight = Math.round(colWidth * 1.4 + infoHeightApprox + gridGap);
      setColumns(cols);
      setRowHeight(estimatedRowHeight);
    };

    compute();
    const ro = new ResizeObserver(compute);
    ro.observe(el);

    return () => ro.disconnect();
  }, [parentRef, minColWidth, gridGap, rowPadding, infoHeightApprox]);

  return { columns, rowHeight, setRowHeight };
}
